import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { getDailyActiveRecommendationDbSelector } from "../../recommendationDailyQuerySelector";
import { OrganisationDailyOffHoursRecommendation } from "../../../../../../services/cloudchipr.api";

export const recommendationDbDailyActiveDataSelector = createDraftSafeSelector(
  [getDailyActiveRecommendationDbSelector],
  (response): OrganisationDailyOffHoursRecommendation[] => response?.data ?? [],
);
